module.exports = __webpack_public_path__ + "static/Photo02-27a8640c5fdd4c474ebddf159e5847dc.png";